import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileAvatar } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileSubTitle } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList,{attrs:{"two-line":""}},_vm._l((_vm.annotations),function(anno){return _c(VListTile,{key:anno.id,attrs:{"avatar":""}},[_c(VListTileAvatar,[_c('img',{attrs:{"src":" "}})]),_c(VListTileContent,[_c(VListTileTitle,{domProps:{"innerHTML":_vm._s(anno.text)}}),_c(VListTileSubTitle,[_vm._v("x: "+_vm._s(anno.x)+", y: "+_vm._s(anno.y)+", w: "+_vm._s(anno.width)+", h: "+_vm._s(anno.height))])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }